import React, { memo } from 'react'
import { Select } from '@guillotinaweb/react-gmi'
import { I18NField } from '../../../components/i18nfield'
import { frontThemes } from '../../../consts'
import { SelectLandings } from '../../../components/select-landing'

const Empty = () => null

export const BlogPostsForm = memo(({ selected, edit, langs }) => {
  return (
    <I18NField key={langs.join()} langs={langs} Widget={Empty}>
      {(lang) => (
        <>
          <label className="label mt10">Posts</label>
          <SelectLandings
            key={lang}
            value={selected.posts_ids[lang]}
            template="blog-post"
            onChange={(ids) =>
              edit('posts_ids', {
                ...selected.posts_ids,
                [lang]: ids,
              })
            }
          />

          <label className="label mt10">Theme</label>
          <Select
            options={frontThemes.map((k) => ({ label: k, value: k }))}
            value={selected.theme}
            onChange={(e) => edit('theme', e.target.value)}
          />
        </>
      )}
    </I18NField>
  )
})
